<template>
  <v-card class="card-container">
    <v-dialog max-width="600" v-model="detail">
      <DetailModal
        :id="itemId"
        :key="detailKey"
        @close="detail = false"
        :unidadeId="filter.unidadeId"
      />
    </v-dialog>

    <div class="main-toolbar mb-2 align-center">
      <div class="icon-back">
        <v-icon id="icon" size="37" color="white"> mdi-alert-octagon </v-icon>
      </div>

      <span class="main-toolbar-title">{{
        $t('Relatórios - Alertas de Tecnovigilância')
      }}</span>

      <v-spacer></v-spacer>
      <v-btn class="secondary-button ma-1" depressed @click="excel">
        Excel
      </v-btn>
    </div>

    <v-row class="d-flex justify-end ma-0">
      <v-col cols="12" sm="3" class="mx-1 pa-0 my-1">
        <v-menu
          ref="menuStartDate"
          v-model="menuStartDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              clearable
              hide-details="auto"
              v-model="startDate"
              placeholder="Data inicial"
              v-mask="['##/##/####']"
              prepend-inner-icon="mdi-calendar"
              @blur="calledStartDate = parseDate(startDate)"
              v-bind="attrs"
              v-on="on"
              autocomplete="off"
              outlined
              class="primary-input mr-2"
              @keyup.enter="list"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="calledStartDate"
            min="1900-01-01"
            @change="save"
            locale="pt"
            no-title
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="3" class="mx-1 pa-0 my-1">
        <v-menu
          ref="menuEndDate"
          v-model="menuEndDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              clearable
              hide-details="auto"
              placeholder="Data final"
              :disabled="!startDate"
              v-model="endDate"
              v-mask="['##/##/####']"
              prepend-inner-icon="mdi-calendar"
              @blur="calledEndDate = parseDate(endDate)"
              v-bind="attrs"
              v-on="on"
              name="endDate"
              autocomplete="off"
              outlined
              class="primary-input mr-2"
              @keyup.enter="list"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="calledEndDate"
            @change="save"
            locale="pt"
            no-title
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="3" class="mx-1 pa-0 my-1">
        <v-autocomplete
          v-model="filter.unidadeId"
          :items="unidades"
          item-text="name"
          item-value="id"
          hide-details="auto"
          outlined
          dense
          class="primary-input ma-0 pa-0"
          append-icon="mdi-chevron-down"
          :label="$t('Unidade')"
        ></v-autocomplete>
      </v-col>

      <v-btn
        @click=";(filter.page = 1), list()"
        class="ma-1 ml-2 primary-button"
        depressed
      >
        {{ $t('Filtrar') }}
      </v-btn>
    </v-row>

    <div class="d-flex align-center">
      <v-spacer></v-spacer>
    </div>

    <div class="d-flex justify-end align-center">
      <span>{{ $t('Status ANVISA') }}:</span>
      <strong class="ml-1" :style="isOnline ? 'color: green' : 'color: red'">
        {{ isOnline ? 'Online' : 'Offline' }}
      </strong>
    </div>

    <v-data-table
      :loading="loading"
      :header-props="headerProps"
      :headers="headers"
      :items="items"
      :items-per-page="filter.pageSize"
      hide-default-footer
      hide-default-header
      class="main-table"
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>

      <template #[`item.userViewed`]="{ item }">
        {{ item.userViewed ? item.userViewed : $t('Sem registro') }}
      </template>

      <template #[`item.viewedDate`]="{ item }">
        {{ item.viewedDate ? formatDate(item.viewedDate) : $t('Sem registro') }}
      </template>

      <template #[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>

      <template #[`item.viewed`]="{ item }">
        <v-chip
          v-if="institution.userType == 2 || institution.userType == 4"
          outlined
          :color="item.viewed ? 'secondary' : 'error'"
        >
          <v-icon v-if="item.viewed" class="mr-2" small>mdi-check</v-icon>
          {{ item.viewed ? 'Visto' : 'Pendente' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              small
              color="#f5f5f5"
              dark
              @click="
                ;(itemId = item.id), (detailKey = !detailKey), (detail = true)
              "
              v-bind="attrs"
              v-on="on"
              depressed
            >
              <v-icon small color="#bbcf20">mdi-eye-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Detalhar') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              @click="markAsViewed(item.id)"
              :href="item.link"
              target="_blank"
              v-bind="attrs"
              v-on="on"
              depressed
              small
            >
              <v-icon small dark> mdi-link </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Acessar alerta') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ filter.pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="filter.pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="filter.page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import moment from 'moment'
import DetailModal from './components/detail.vue'
import selectInstVue from '../Reports/components/GenerateReport/components/selectInst.vue'

export default {
  name: 'tecnovigilanciaPage',

  components: {
    DetailModal,
  },

  data() {
    return {
      startDate: null,
      endDate: null,
      calledEndDate: null,
      calledStartDate: null,
      menuStartDate: false,
      menuEndDate: false,
      minDate: null,
      unidades: [],
      sizes: [10, 30, 90, 180],
      itemId: '',
      detailKey: false,
      detail: false,
      apiService: new ApiService(),
      loading: false,
      items: [],
      totalPages: null,
      filter: {
        page: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
      },
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'number',
        },
        {
          text: 'Núm. Anvisa',
          align: 'center',
          value: 'anvisaNumber',
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
        },
        {
          text: 'Data da visualização',
          align: 'center',
          value: 'viewedDate',
          sortable: false,
        },
        {
          text: 'Usuário que visualizou',
          align: 'center',
          value: 'userViewed',
          sortable: false,
        },
        {
          align: 'center',
          value: 'viewed',
          sortable: false,
          width: '60',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      isOnline: false,
      user: {},
      interval: null,
      institution: {},
    }
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()

    if (this.institution.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    this.checkIfAnvisaIsOnline()
    this.interval = setInterval(() => {
      this.checkIfAnvisaIsOnline()
    }, 120000)
  },

  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },

  methods: {
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.calledStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.calledStartDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.calledEndDate)
      this.$refs.menuEndDate.save(date)
    },
    async getUnidades() {
      await this.apiService
        .get(`unidade/list/${this.filter.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
    },

    async getUserUnidades() {
      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.filter.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
    },

    checkIfAnvisaIsOnline() {
      this.apiService
        .get('tecnovigilancia/check-if-anvisa-is-online', true, false)
        .then((response) => {
          this.isOnline = response.content
        })
    },

    excel() {
      this.apiService
        .get('tecnovigilancia/excel', this.filter)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', 'alertas-tecnovigilancia.xlsx')
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    formatDate(date) {
      return moment(date).format('DD/MM/yyyy')
    },

    markAsViewed(itemId) {
      if (
        this.institution.userType == 2 ||
        this.institution.userType == 8 ||
        this.institution.userType == 4 ||
        this.institution.userType == 5
      ) {
        this.apiService
          .get(`tecnovigilancia/mark-viewed/${itemId}`)
          .then(() => {
            this.list()
          })
      }
    },

    list() {
      this.loading = true

      this.filter.startDate = this.calledStartDate
      this.filter.endDate = this.calledEndDate
      this.apiService
        .post('tecnovigilancia/list', this.filter)
        .then((response) => {
          this.items = response.content.alerts
          this.totalPages = response.content.pager.totalPages
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },

  watch: {
    'filter.pageSize': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
  },
}
</script>

<style scoped></style>
